$('#privacy_policy_trigger').click(() => {
  $('.modal__privacy_policy').show();
});
$('#terms-of-use_trigger').click(() => {
  $('.modal__terms-of-use').show();
});
$('.modal-close__footer-modal').click(() => {
  $('.modal-box').hide()
});